const service = {
  codeTypePropertyNames: ['naicsCode', 'nigpCode'],
};

export default service;
